@if (canExportPDF()) {
  <p-button
    [label]="'companyReport.button' | transloco"
    icon="pi pi-file-pdf"
    [outlined]="true"
    (onClick)="showModal.set(true)"
  />
} @else {
  <app-locked-button
    [label]="'companyReport.button' | transloco"
    [limitedFeature]="pdfFeature"
  />
}
<app-company-report-modal [(visible)]="showModal" />
